import { PARCEL_SERVICE_URL } from '../../map/constants'
import { RESULT_TYPES } from '../constants'


const processResults = (Polygon, features) => {
  return {
    id: RESULT_TYPES.PIN,
    title: 'PINs',
    showResults: false,
    results: features.map(f => ({
      label: f.attributes.PINtext,
      attributes: f.attributes,
      geometry: new Polygon(f.geometry)
    }))
  }
}

export const pinSearch = async (Polygon, searchTerm, callback) => {
  const whereClause = encodeURIComponent(`PINtext LIKE '%${searchTerm}%'`)
  const response = await fetch(`${PARCEL_SERVICE_URL}/query?where=${whereClause}&outFields=*&returnGeometry=true&outSR=4326&f=pjson`)
  const results = await response.json()
  const formattedResults = processResults(Polygon, results.features)
  if (formattedResults && formattedResults.results.length) callback(formattedResults)
}